import { ApolloClient, NormalizedCacheObject, useMutation, useQuery } from '@apollo/client';
import GraphQL, { PublicGraphQL } from '../../membership/gql';
import {
  ProfileData,
  ProfileVars,
  SaveProfileData,
  SaveProfileVars
} from 'membership/gql-types';

import ApolloClientService from '../services/ApolloClientService';
import AuthService from '../services/AuthService';
import Config from '../config';
import { ProfileUpdate } from '../models/Profile';
import TenantService from '../services/TenantService';

let membershipApolloClient: ApolloClient<NormalizedCacheObject | null> = null;
let membershipPublicApolloClient: ApolloClient<NormalizedCacheObject | null> =
  null;

/**
 * Use tenant-level listing of all profiles in the skin.
 */
const useProfileData = () => {
  if (!membershipApolloClient) {
    membershipApolloClient = ApolloClientService.create(Config.MEMBERSHIP_GQL);
    membershipPublicApolloClient = ApolloClientService.create(
      Config.MEMBERSHIP_PUBLIC_GQL
    );
  }

  const {
    loading: profileLoading,
    error: profileError,
    data: profileData
  } = useQuery<ProfileData, ProfileVars>(PublicGraphQL.Query.PROFILE, {
    client: membershipPublicApolloClient,
    variables: {
      tenant: AuthService.Tenant
    },
    fetchPolicy: 'cache-and-network',
    skip: !membershipPublicApolloClient
  });

  const [_saveProfile, { loading: saving, error: saveError, data: saveData }] =
    useMutation<SaveProfileData, SaveProfileVars>(
      GraphQL.Mutation.SAVE_PROFILE,
      { client: membershipApolloClient }
    );

  return {
    profileLoading,
    profileError,
    /** All profiles in the tenant. */
    profileData,
    /** Save some parts of a profile to the server. */
    saveProfile: (profile: ProfileUpdate) =>
      _saveProfile({ variables: { tenant: TenantService.Tenant, profile } }),
    saving,
    saveError,
    saveData
  };
};

export default useProfileData;
